import React, { useState, useEffect } from 'react'
import useAxios from 'axios-hooks'
import { withTheme } from 'theming'
import AddSection from '../addSection'
import EditMenu from '../editMenu'
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu'
import useTemplateHook from '../templateHook'
import { isEmpty } from 'lodash'
import CategoryNavigatorSwimlane from './categoryNavigatorSwimlane'

const CategoryNavigatorCards = ({
  componentData,
  modifyData,
  setModalState,
  isEdit,
  onSwap,
  onDelete,
  onCopy,
  theme,
  onAdd,
  iptvPage = false,
}) => {
  const { data, id, component_key } = componentData

  const { KalingoLeftArrow, KalingoRightArrow, IPTV_CHANNEL_FILTER_XAVIER, CONTENT_FILTER_XAVIER } =
    useTemplateHook()
  const [hoverState, setHoverState] = useState('')
  const [hoverCategory, setHoverCategory] = useState('')
  const [activeCategory, setActiveCategory] = useState('')
  const [categoryWiseData, setCategoryWiseData] = useState({})

  const isAoSportsComponent = `${component_key}`.includes('AoSports')

  const [{ loading: channelListLoading }, channelListCall] = useAxios(
    {
      url: IPTV_CHANNEL_FILTER_XAVIER,
      method: 'post',
    },
    {
      manual: true,
      autoCancel: false,
    },
  )

  const [{ loading: contentListLoading }, contentListCall] = useAxios(
    {
      url: CONTENT_FILTER_XAVIER,
      method: 'post',
    },
    {
      manual: true,
      autoCancel: false,
    },
  )

  const getDynamicFilters = (autoPayload) => {
    let obj = {}

    let ownersObj = autoPayload.find((info) => info.type === 'owners')

    if (ownersObj) {
      obj['owners'] = ownersObj?.values
    }

    return obj
  }

  useEffect(() => {
    let isCancelled = false

    const getListFromResponse = (response) => {
      if (Array.isArray(response?.data?.data)) return response.data.data
      if (Array.isArray(response?.data?.data?.results)) return response.data.data.results
      if (Array.isArray(response?.data?.results)) return response.data.results
      if (Array.isArray(response?.data)) return response.data
      return []
    }

    const normalizeContentData = (list = []) => {
      if (!Array.isArray(list)) return []

      return list.map((item) => ({
        thumbnail: item?.thumbnail,
        id: item?.content_id,
        title: item?.title,
        content_type: 'CONTENT',
      }))
    }

    const normalizeIptvData = (list = []) => {
      if (!Array.isArray(list)) return []

      return list.map((item) => ({
        title: item?.name,
        thumbnail: item?.thumbnail?.website?.s3_key || '',
        id: item?._id,
        content_type: 'IPTV',
      }))
    }

    const loadCategoryWiseData = async () => {
      if (!data?.card_data || data.card_data.length === 0) {
        if (!isCancelled) {
          setCategoryWiseData({})
        }
        return
      }

      if (!isCancelled) {
        setActiveCategory(data.card_data[0]?.category_key || '')
      }

      const categoryFetches = data.card_data.map(async (element) => {
        const categoryKey = element?.category_key
        if (!categoryKey) {
          return null
        }

        const swimlaneData = element?.swimlane_data || element
        const swimlaneType = swimlaneData?.swimlane_type || element?.swimlane_type
        const swimlaneContentData = Array.isArray(swimlaneData?.content_data)
          ? swimlaneData.content_data
          : []
        const elementContentData = Array.isArray(element?.content_data) ? element.content_data : []
        const contentData =
          swimlaneContentData.length > 0
            ? swimlaneContentData
            : elementContentData.length > 0
            ? elementContentData
            : []
        const swimlaneAutoPayload = Array.isArray(swimlaneData?.auto_payload)
          ? swimlaneData.auto_payload
          : []
        const elementAutoPayload = Array.isArray(element?.auto_payload) ? element.auto_payload : []
        const autoPayload =
          swimlaneAutoPayload.length > 0
            ? swimlaneAutoPayload
            : elementAutoPayload.length > 0
            ? elementAutoPayload
            : []

        const hasContentData = contentData.length > 0
        const hasAutoPayload = autoPayload.length > 0

        if (!hasContentData && !hasAutoPayload) {
          return { categoryKey, list: [] }
        }

        try {
          if (swimlaneType === 'IPTV') {
            if (hasContentData) {
              const response = await channelListCall({
                data: {
                  filters: {
                    channel_ids: contentData,
                  },
                  page: 1,
                  order_by: 'modified_date',
                  page_size: contentData.length,
                },
              })

              return { categoryKey, list: normalizeIptvData(getListFromResponse(response)) }
            }

            const response = await channelListCall({
              data: {
                filters: {
                  system_defined: autoPayload.filter((info) => info.type === 'system_defined'),
                  custom_defined: autoPayload.filter((info) => info.type === 'custom_defined'),
                },
                page: 1,
                order_by: 'modified_date',
                reverse: false,
                page_size: 100,
              },
            })

            return { categoryKey, list: normalizeIptvData(getListFromResponse(response)) }
          }

          if (swimlaneType === 'CONTENT') {
            if (hasContentData) {
              const response = await contentListCall({
                data: {
                  filters: {
                    content_ids: contentData,
                  },
                  page: 1,
                  order_by: 'modified_date',
                  page_size: contentData.length,
                },
              })

              return { categoryKey, list: normalizeContentData(getListFromResponse(response)) }
            }

            const response = await contentListCall({
              data: {
                filters: {
                  system_defined: autoPayload.filter((info) => info.type === 'system_defined'),
                  custom_defined: autoPayload.filter((info) => info.type === 'custom_defined'),
                  video_types: ['SPV', 'MPVP', 'MPVC', 'LIVE', 'VOD_LIVE', 'PLAYLIST'],
                  ...getDynamicFilters(autoPayload),
                },
                page: 1,
                order_by: 'modified_date',
                reverse: false,
                page_size: 100,
              },
            })

            return { categoryKey, list: normalizeContentData(getListFromResponse(response)) }
          }
        } catch (error) {
          console.error(`Category fetch failed for ${categoryKey}`, {
            message: error?.message,
            status: error?.response?.status,
            data: error?.response?.data,
          })
          return { categoryKey, list: [] }
        }

        return { categoryKey, list: [] }
      })

      const fetchResults = await Promise.allSettled(categoryFetches)
      const nextCategoryData = {}

      fetchResults.forEach((result) => {
        if (result.status === 'fulfilled' && result.value?.categoryKey) {
          nextCategoryData[result.value.categoryKey] = result.value.list || []
        }
      })

      if (!isCancelled) {
        setCategoryWiseData(nextCategoryData)
      }
    }

    loadCategoryWiseData()

    return () => {
      isCancelled = true
    }
  }, [data?.card_data, channelListCall, contentListCall])

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }
  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey].data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  const getCategoryBgColor = (categoryKey) => {
    if (!data?.style_config) {
      return ''
    }

    if (categoryKey === activeCategory) {
      return getStyleValue('category_style', 'active_color', '#fe400f')
    }
    if (categoryKey === hoverCategory) {
      return getStyleValue('category_style', 'hover_color', '')
    }
    return getStyleValue('category_style', 'default_color', '#11171f')
  }

  function LeftArrow() {
    const { isFirstItemVisible, scrollPrev } = React.useContext(VisibilityContext)
    return (
      <button
        className={`absolute left-0 z-10 bg-transparent px-0 hidden lg:flex justify-center ${
          isFirstItemVisible ? 'opacity-0' : 'opacity-100'
        } `}
        disabled={isFirstItemVisible}
        onClick={() => scrollPrev()}
        title="Previous Item"
        style={{ width: '3.66032%', top: '5%' }}
      >
        <img src={KalingoLeftArrow} style={{ height: '37px' }} alt="KalingoLeftArrow" />
      </button>
    )
  }

  function RightArrow() {
    const { isLastItemVisible, scrollNext } = React.useContext(VisibilityContext)
    return (
      <button
        className={`absolute right-0 z-10 bg-transparent px-0 hidden lg:flex justify-center ${
          isLastItemVisible ? 'opacity-0' : 'opacity-100'
        }`}
        disabled={isLastItemVisible}
        onClick={() => scrollNext()}
        title="Next Item"
        style={{ width: '3.66032%', top: '5%' }}
      >
        <img src={KalingoRightArrow} style={{ height: '37px' }} alt="KalingoLeftArrow" />
      </button>
    )
  }

  return (
    <div
      className={`w-full relative ${isEdit && hoverState && 'component-hover-class'}`}
      style={{
        backgroundColor: getStyleValue('component_background', 'primary_color', ''),
      }}
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
    >
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onDelete={() => onDelete(id)}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
          onEdit={() => handleModal()}
          onCopy={() => onCopy(id)}
        />
      )}
      <div className="py-[16px] lg:py-8">
        {!iptvPage ? (
          <div
            style={{
              color: getStyleValue('heading', 'color', '#ffffff'),
              padding: '0px 3.66032%',
            }}
          >
            <h2
              style={{
                borderColor: isAoSportsComponent
                  ? getStyleValue('heading', 'line_color', '#E4022B')
                  : '',
              }}
              className={`${
                isAoSportsComponent
                  ? 'border-l-4 pl-3 text-[21px] leading-[1.1] flex items-center justify-between font-bold'
                  : 'xl:text-2xl md:text-xl text-xs font-semibold'
              } `}
            >
              {data?.title}
            </h2>
          </div>
        ) : null}

        <div
          style={{
            padding: '0px 3.66032%',
          }}
          className="w-full mt-2 md:mt-4 relative"
        >
          <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow} wrapperClassName="w-full">
            {data?.card_data &&
              [...data?.card_data].map((info, index) => (
                <CategoryCard
                  key={index}
                  itemId={`index${index}`}
                  index={index}
                  info={info}
                  activeCategory={activeCategory}
                  setActiveCategory={setActiveCategory}
                  setHoverCategory={setHoverCategory}
                  getCategoryBgColor={getCategoryBgColor}
                  getStyleValue={getStyleValue}
                />
              ))}
          </ScrollMenu>
        </div>
        <div className="w-full mt-2.5 lg:mt-6 h-[90px] lg:h-[160px]">
          {!channelListLoading &&
          !contentListLoading &&
          activeCategory &&
          categoryWiseData[activeCategory] &&
          categoryWiseData[activeCategory].length > 0 ? (
            <CategoryNavigatorSwimlane
              data={categoryWiseData[activeCategory]}
              getStyleValue={getStyleValue}
            />
          ) : null}
          {channelListLoading || contentListLoading ? (
            <div
              style={{ padding: '0px 3.66032%' }}
              className="w-full h-full flex items-start justify-start"
            >
              {[...Array(5)].map((_, index) => (
                <div
                  key={index}
                  className={` w-[96.4px] lg:w-[183px]  ${
                    index && 'ml-2.5 lg:ml-6'
                  } animate-pulse rounded xl:rounded-md`}
                  style={{
                    aspectRatio: '16/9',
                    backgroundColor: '#00000080',
                  }}
                ></div>
              ))}
            </div>
          ) : null}
        </div>
      </div>
      {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
    </div>
  )
}

function CategoryCard({
  index,
  info,
  activeCategory,
  setActiveCategory,
  setHoverCategory,
  getCategoryBgColor,
  getStyleValue,
}) {
  return (
    <div
      style={{
        backgroundColor: getCategoryBgColor(info.category_key),
        color: getStyleValue('category_style', 'text_color', '#eaeaea'),
        border: `1px solid ${
          info.category_key === activeCategory
            ? getStyleValue('category_style', 'active_color', '#fe400f')
            : getStyleValue('category_style', 'border_color', '#727272')
        }`,
      }}
      key={index}
      className={`cursor-pointer flex items-center justify-center text-[10px] lg:text-xs rounded xl:rounded-md w-[96.4px] lg:w-[183px] h-[22px] lg:h-[40px] ${
        index && 'ml-2.5 lg:ml-6'
      }`}
      onClick={() => {
        setActiveCategory(info.category_key)
      }}
      onMouseOver={() => setHoverCategory(info.category_key)}
      onMouseLeave={() => setHoverCategory('')}
    >
      {info.category_name}
    </div>
  )
}

export default withTheme(CategoryNavigatorCards)
